import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import { useIntl, FormattedMessage } from "react-intl";
import { AppContext } from "contexts/app";
import stylesLess from "./index.module.less";
import sessionStorage from "utils/sessionStorage";
import { getAbsoluteUrl } from "utils/method";
// import { get_checkCountryIpIsIntercept } from "api/uaapi/user";

import AntdModalAlert from "components/Antd/Modal/Alert";
import ButtonBig from "components/Antd/Button/big";
import FormItem from "components/App/FormItem";
import Layout from "./_CMPT/Layout";
import CountryList from "components/App/Country";

import imageLocal from "assets/images/local.svg";

export default function Register() {
  const intl = useIntl();
  const router = useRouter();
  const [appState, appDispatch] = React.useContext(AppContext);

  const [state_countryInfo, setState_countryInfo] = React.useState(null);
  const [state_loading, setState_loading] = React.useState(false);
  React.useEffect(() => {
    try {
      sensors.track("RegisterPage", {
        from_page: router.query.backurl || "",
      });
    } catch (error) {}
  }, []);

  const updateCountryInfo = (obj) => {
    setState_countryInfo(obj);
  };

  const handleClick = () => {
    sessionStorage.set("countryInfo", state_countryInfo);
    if (typeof location !== "undefined")
      return (location.href = getAbsoluteUrl({
        pathname: "/register/start",
        locale: router.locale,
        query: router.query,
      }));
    return router.push({
      pathname: "/register/start",
      query: router.query,
    });
    // if (state_loading) return;
    // setState_loading(true);
    // get_checkCountryIpIsIntercept({ errorPop: true })
    //   .then((data) => {
    //     if (!data.isIntercept) {
    //       sessionStorage.set("countryInfo", state_countryInfo);
    //       return router.push({
    //         pathname: "/register/start",
    //         query: router.query,
    //       });
    //     }

    //     AntdModalAlert({
    //       isDark: appState.isDark,
    //       inner: (
    //         <div style={{ textAlign: "center" }}>
    //           <Image src={imageLocal} alt="local" />
    //           <div style={{ marginTop: "20px" }}>
    //             {intl.formatMessage({ id: "register.ipIsIntercept" })}
    //           </div>
    //         </div>
    //       ),
    //     });
    //   })
    //   .finally(() => {
    //     setState_loading(false);
    //   });
  };

  return (
    <Layout countryInfo={state_countryInfo}>
      <div
        className={`${stylesLess.main} ${appState.isDark ? "dark" : "light"}`}
      >
        <h1 className="iHead">
          <FormattedMessage id="app.saas.helloAlpha" />
        </h1>
        <p className="iDesc">
          <FormattedMessage id="register.saas.locationTip" />
        </p>

        <div className={"iForm"}>
          <div>
            <FormItem
              title={<FormattedMessage id="register.countryResidence" />}
            >
              <CountryList
                selectItem={updateCountryInfo}
                countryQuery="REG" //REG: 注册场景 , MOBILE: 手机
                showType="Large" //Large:大显示框， Small:小显示框
              />
            </FormItem>
          </div>

          <div className="iBtn">
            <ButtonBig
              onClick={handleClick}
              disabled={!state_countryInfo}
              loading={state_loading}
            >
              <FormattedMessage id="app.confirm" />
            </ButtonBig>
          </div>

          <div className="iTip">
            <FormattedMessage
              id="register.isRegistered"
              values={{
                0: (
                  // <Link href={{ pathname: "/login", query: router.query }}>
                  <a
                    href={getAbsoluteUrl({
                      pathname: "/login",
                      locale: router.locale,
                      query: router.query,
                    })}
                  >
                    <FormattedMessage id="app.login" />
                  </a>
                  // </Link>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
